import { FC, ReactNode } from 'react';
import useAuthorization from '@/features/auth/hooks/useAuthorization';
import { TenantFeatures } from '@/features/auth/enums';

interface FeatureGateT {
  feature?: TenantFeatures;
  fallback: ReactNode;
  children: ReactNode;
}

const FeatureGate: FC<FeatureGateT> = ({ feature, fallback, children }) => {
  const { isAccessGranted } = useAuthorization();

  if (!isAccessGranted({ feature })) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default FeatureGate;
